import {
  endOfYear,
  lastDayOfMonth,
  startOfMonth,
  startOfYear,
  subDays,
  subMonths,
  subYears,
} from 'date-fns';

import { getServerDate } from '@/shared/lib/utils/getServerDate';

export function getDateRangePickerPeriods() {
  const today = getServerDate();
  const yesterday = subDays(today, 1);
  const past6days = subDays(today, 6);
  const past29days = subDays(today, 29);
  const prevMonth = subMonths(today, 1);
  const prevYear = subYears(today, 1);

  const periods = [
    { children: 'Today', value: [today, today] },
    { children: 'Yesterday', value: [yesterday, yesterday] },
    { children: 'Last 7 days', value: [past6days, today] },
    { children: 'Last 30 days', value: [past29days, today] },
    { children: 'This Month', value: [startOfMonth(today), today] },
    {
      children: 'Last Month',
      value: [startOfMonth(prevMonth), lastDayOfMonth(prevMonth)],
    },
    { children: 'This Year', value: [startOfYear(today), today] },
    {
      children: 'Last Year',
      value: [startOfYear(prevYear), endOfYear(prevYear)],
    },
  ];

  return periods;
}
